import { useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { useGame } from '@/store/game';
import { useCalm } from './time';

/** One short message at the top of the screen ("Welcome back, Sam."), a square-cornered tag, gone after a few seconds. */
export function Toast() {
  const toast = useGame((s) => s.toast); const clear = useGame((s) => s.clearToast); const reduce = useCalm();
  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(() => clear(toast.id), 3600);
    return () => window.clearTimeout(t);
  }, [toast, clear]);
  return (
    <div role="status" aria-live="polite" className="pointer-events-none fixed inset-x-0 top-0 z-50 flex justify-center px-4 pt-[max(0.75rem,env(safe-area-inset-top))]">
      <AnimatePresence>
        {toast && (
          <motion.p key={toast.id} onClick={() => clear(toast.id)}
            initial={reduce ? { opacity: 0 } : { opacity: 0, y: -28, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={reduce ? { opacity: 0 } : { opacity: 0, y: -16 }}
            transition={{ type: 'spring', stiffness: 420, damping: 30 }}
            className="pointer-events-auto flex max-w-full items-center rounded-badge bg-ink px-4 py-2.5 text-[15px] font-semibold text-surface shadow-pop">
            <span className="min-w-0">{toast.text}</span>
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
}
